/**
 * The person's Thrive & HubSpot history (04). Keyed by handle only — nu-sync's
 * answer does not depend on which list the panel is open over.
 *
 * Its failure is CONTAINED: a 503 (`nu_sync_unavailable`) renders inline in the
 * Thrive & HubSpot tab and the aside, and the other tabs are unaffected, which
 * is why this is a separate query rather than part of `usePerson`.
 */
import { skipToken, useQuery } from "@tanstack/react-query";

import type { PeopleClient } from "../../clients/people.client";

export function relationshipQueryKey(handle: string): readonly unknown[] {
  return ["person-relationship", handle];
}

export function useRelationship(client: PeopleClient, handle: string | null) {
  return useQuery({
    queryKey: relationshipQueryKey(handle ?? ""),
    // Aborted like the person read when ‹ › moves on before it answers.
    queryFn: handle ? ({ signal }) => client.getRelationship(handle, { signal }) : skipToken,
    // The route already waited up to 2 s on nu-sync; retrying a 503 three
    // times would hold the tab on a spinner for the better part of 10 s.
    retry: false,
    staleTime: 60 * 1000,
  });
}
